import { THEME_SWITCH } from './types'

export const switchTheme = (theme: any) => (dispatch: any) => {
    dispatch({
        type: THEME_SWITCH,
        payload: {
            theme,
        },
    })
}
